import { ripeLemon } from '@paradigm/design-system/src/colors';

const markPriceHedgeWarnSymbol = (
  <sup
    css={`
      color: ${ripeLemon};
      font-size: 8px;
      position: relative;
      top: -6px;
    `}
  >
    ▲
  </sup>
);

export default markPriceHedgeWarnSymbol;
